import React from "react";
import { Box } from "@mui/material";

const VideoSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: 6,
        px: 2,
        backgroundColor: "#fff", // optional styling
        display: "flex",
        justifyContent: "center",
      }}
      className="video-section section-wrap"
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px", // adjust max width
          aspectRatio: "16/9", // ensures responsive video
          position: "relative",
        }}
        className="video-wrapper"
      >
        <Box
          component="iframe"
          src="https://www.youtube.com/embed/z1KRpzZ1eGs"
          title="Court Mediation कैसे कराता है? Court में Mediation में क्या होता है? Court Mediation👍"
          sx={{
            width: "100%",
            height: "100%",
            border: 0,
            position: "absolute",
            top: 0,
            left: 0,
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    </Box>
  );
};

export default VideoSection;
